import { Button } from '@factorialco/factorial-one-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface ConfirmationModalProps {
  onClose: () => void
  onSubmit: () => void
}

export function ConfirmationModal({ onClose, onSubmit }: ConfirmationModalProps) {
  return (
    <Modal
      title={i18n.t('compensations.integrations.sync_confirmation_modal.title')}
      description={i18n.t('compensations.integrations.sync_confirmation_modal.description')}
      illustration="sync"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button
            onClick={onClose}
            variant="outline"
            label={i18n.t('compensations.integrations.sync_confirmation_modal.cancel_cta')}
          />
          <Button
            variant="default"
            label={i18n.t('compensations.integrations.sync_confirmation_modal.sync_cta')}
          />
        </>
      }
    />
  )
}
